export async function fullOsAndDevicesRestart() {
  await fab.lfs_test.restart().catch(() => {});
  await fab.cardprog.restart().catch(() => {});

  await fab.os.reboot();
}
